// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_fieldset__U6wzi {
  border: 1px solid #6ba7a8;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-width: unset;
  max-width: 100%;
  gap: 4px;
}
.styles_fieldset__U6wzi legend {
  font-weight: 500;
  color: #6ba7a8;
  padding: 0 8px;
}
.styles_fieldset__U6wzi .styles_container__xmbwJ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 14px;
}
.styles_fieldset__U6wzi .styles_container__xmbwJ .styles_wrapper__3wBSX {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}
.styles_fieldset__U6wzi .styles_container__xmbwJ .styles_wrapper__3wBSX label {
  min-width: 41px;
}
.styles_fieldset__U6wzi .styles_container__xmbwJ .styles_wrapper__3wBSX input {
  width: 100%;
}
.styles_fieldset__U6wzi .styles_cta__a6AGp {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.styles_fieldset__U6wzi .styles_cta__a6AGp button {
  margin-top: 8px;
  background-color: #6ba7a8;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s;
}
.styles_fieldset__U6wzi .styles_cta__a6AGp button:hover {
  background-color: #5a8f90;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptList/FilterSort/FilterByDate/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AACJ;AAAI;EACE,gBAAA;EACA,cAAA;EACA,cAAA;AAEN;AAAI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAEN;AAAM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAER;AAAQ;EACI,eAAA;AAEZ;AAAQ;EACI,WAAA;AAEZ;AAEI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAAN;AACM;EACE,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AACR;AAAQ;EACE,yBAAA;AAEV","sourcesContent":[".fieldset {\n    border: 1px solid #6ba7a8;\n    padding: 12px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    min-width: unset;\n    max-width: 100%;\n    gap: 4px;\n    legend {\n      font-weight: 500;\n      color: #6ba7a8;\n      padding: 0 8px;\n    }\n    .container {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 4px;\n      font-size: 14px;\n\n      .wrapper{\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        label{\n            min-width: 41px;\n        }\n        input{\n            width: 100%;\n        }\n      }\n    }\n    .cta{\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      button{\n        margin-top: 8px;\n        background-color: #6ba7a8;\n        color: white;\n        border: none;\n        padding: 4px 8px;\n        border-radius: 8px;\n        cursor: pointer;\n        font-size: 14px;\n        font-weight: 500;\n        transition: background-color 0.3s;\n        &:hover{\n          background-color: #5a8f90;\n        }\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldset": `styles_fieldset__U6wzi`,
	"container": `styles_container__xmbwJ`,
	"wrapper": `styles_wrapper__3wBSX`,
	"cta": `styles_cta__a6AGp`
};
export default ___CSS_LOADER_EXPORT___;
